/*
 * @Description: 
 * @Author: xiaoyao
 * @since: 2019-06-11 15:26:08
 * @LastAuthor: xiaoyao
 * @lastTime: 2020-08-03 17:15:40
 */
import Mock from 'mockjs2'

// 判断环境不是 prod 或者 preview 是 true 时，加载 mock 服务
if (process.env.NODE_ENV !== 'production' || process.env.VUE_APP_PREVIEW === 'true') {
    // 使用同步加载依赖
    // 防止 vuex 中的 GetInfo 早于 mock 运行，导致无法 mock 请求返回结果
    console.log('mock mounting')
    require('./services/user')
    require('./services/manage')
    require('./services/other')
    require('./services/tagCloud')
    require('./services/article')
    // require('./services/order')
    require('./services/list')
    // require('./services/settings')
    // require('./user')

    Mock.setup({
        timeout: 800 // setter delay time
    })
    console.log('mock mounted')
}
require('./services/auth')




// WEBPACK FOOTER //
// ./src/mock/index.js